import Tool from '../../common/tool';
import WmRequest from '../../common/request';
import Config from '../../common/config';
/** 「全部」菜单项 id */
var ALL_CATEGORY_ID = 0;
/**
 * 搜索结果页：请选择软件（按钮下拉开层 + /productcenterApi）
 */
var SearchResultAppPicker = /** @class */ (function () {
    function SearchResultAppPicker(navigate, onSelectionChange) {
        this.categories = [];
        this.allProducts = [];
        this.activeCategoryId = ALL_CATEGORY_ID;
        this.selectedProduct = null;
        this.pendingGid = '';
        this.pendingProductAlias = '';
        this.loaded = false;
        this.panelOpen = false;
        this.navigate = navigate;
        this.onSelectionChange = onSelectionChange;
        this.wmRequest = new WmRequest();
        this.pickerRoot = document.getElementById('search-result-app-picker');
        this.trigger = document.getElementById('search-result-app-trigger');
        this.triggerText = document.getElementById('search-result-app-trigger-text');
        this.panel = document.getElementById('search-result-app-panel');
        this.categoriesEl = document.getElementById('search-result-app-categories');
        this.productsEl = document.getElementById('search-result-app-products');
        this.selectedWrap = document.getElementById('search-result-selected-app');
        this.selectedLogo = document.getElementById('search-result-selected-logo');
        this.selectedName = document.getElementById('search-result-selected-name');
        this.bindEvents();
        this.closePanel();
        this.loadProductData();
    }
    /** 根据 URL 的 g_id 回显已选（仅前端从接口列表匹配，不依赖搜索接口返回） */
    SearchResultAppPicker.prototype.syncFromUrl = function (gId) {
        this.pendingGid = gId || '';
        this.pendingProductAlias = '';
        this.applyPendingSelection();
    };
    /** 帮助中心列表页：根据 URL 产品别名回显已选 */
    SearchResultAppPicker.prototype.syncFromProductAlias = function (alias) {
        this.pendingProductAlias = (alias || '').trim().toLowerCase();
        this.pendingGid = '';
        this.applyPendingSelection();
    };
    SearchResultAppPicker.prototype.extractProductAlias = function (detailsUrl) {
        if (!detailsUrl) {
            return '';
        }
        var path = detailsUrl
            .replace(/^https?:\/\/[^/]+/i, '')
            .replace(/^\//, '')
            .split('?')[0];
        var parts = path.split('/').filter(Boolean);
        return parts[parts.length - 1] || '';
    };
    SearchResultAppPicker.prototype.normalizeProduct = function (raw) {
        var iUrl = (raw.i_url || raw.logo_url || '');
        return {
            g_id: raw.g_id,
            g_name: String(raw.g_name || ''),
            i_url: iUrl,
            logo_url: iUrl,
            details_url: raw.details_url,
            g_website: String(raw.g_website || ''),
            details_desc: String(raw.details_desc || raw.description || ''),
        };
    };
    /** 帮助中心侧栏：当前已选产品（需 productcenterApi 加载完成） */
    SearchResultAppPicker.prototype.getSelectedProduct = function () {
        return this.selectedProduct;
    };
    SearchResultAppPicker.prototype.notifySelectionChange = function () {
        var _a;
        (_a = this.onSelectionChange) === null || _a === void 0 ? void 0 : _a.call(this, this.selectedProduct);
    };
    SearchResultAppPicker.prototype.loadProductData = function () {
        var _this = this;
        this.wmRequest
            .ajax({
            url: Config.PRODUCT_CENTER_API,
            type: 'GET',
            data: { group: 1 },
        })
            .then(function (res) {
            var _a;
            var body = res;
            if (!body || body.code !== 200 || !((_a = body.data) === null || _a === void 0 ? void 0 : _a.groups)) {
                return;
            }
            var flat = [];
            body.data.groups.forEach(function (group) {
                var children = (group.products || []).map(function (p) {
                    return _this.normalizeProduct(p);
                });
                if (!children.length) {
                    return;
                }
                flat.push.apply(flat, children);
                _this.categories.push({
                    id: group.type_id,
                    name: group.goods_type,
                    children: children,
                });
            });
            _this.allProducts = flat;
            _this.loaded = true;
            _this.applyPendingSelection();
            _this.renderCategories();
            _this.renderProducts();
        })
            .catch(function () {
            _this.productsEl.innerHTML = '<p class="daetool-search-result-app-picker__empty">加载失败，请稍后重试</p>';
        });
    };
    SearchResultAppPicker.prototype.applyPendingSelection = function () {
        if (!this.pendingGid && !this.pendingProductAlias) {
            this.clearSelectedUi();
            return;
        }
        if (!this.loaded) {
            return;
        }
        var product = null;
        if (this.pendingGid) {
            product = this.findProductByGid(this.pendingGid);
        }
        else if (this.pendingProductAlias) {
            product = this.findProductByAlias(this.pendingProductAlias);
        }
        if (!product) {
            this.clearSelectedUi();
            return;
        }
        this.selectedProduct = product;
        this.renderSelectedUi();
        this.notifySelectionChange();
    };
    SearchResultAppPicker.prototype.findProductByGid = function (gId) {
        return this.allProducts.find(function (item) { return String(item.g_id) === String(gId); }) || null;
    };
    /** 帮助中心列表：由 g_id 解析 URL 产品段 */
    SearchResultAppPicker.prototype.getProductAliasForGid = function (gId) {
        var product = this.findProductByGid(gId);
        return product ? this.extractProductAlias(product.details_url) : '';
    };
    SearchResultAppPicker.prototype.findProductByAlias = function (alias) {
        var _this = this;
        var key = alias.trim().toLowerCase();
        if (!key) {
            return null;
        }
        return (this.allProducts.find(function (item) {
            var extracted = _this.extractProductAlias(item.details_url).toLowerCase();
            if (extracted === key) {
                return true;
            }
            var rawUrl = (item.details_url || '').toLowerCase();
            return rawUrl.includes("/".concat(key)) || rawUrl.endsWith("/".concat(key, ".html")) || rawUrl.endsWith(key);
        }) || null);
    };
    SearchResultAppPicker.prototype.bindEvents = function () {
        var _this = this;
        var _a;
        this.trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.togglePanel();
        });
        // 下拉里切换分类会重绘 DOM，需在 panel 上拦截冒泡，避免 document 误判为「点外部」
        this.panel.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        document.addEventListener('click', function () {
            if (_this.panelOpen) {
                _this.closePanel();
            }
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && _this.panelOpen) {
                _this.closePanel();
            }
        });
        (_a = document.getElementById('search-result-selected-clear')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (e) {
            e.stopPropagation();
            _this.pendingGid = '';
            _this.pendingProductAlias = '';
            _this.selectedProduct = null;
            _this.navigate(null);
        });
    };
    SearchResultAppPicker.prototype.togglePanel = function () {
        if (this.panelOpen) {
            this.closePanel();
        }
        else {
            this.openPanel();
        }
    };
    SearchResultAppPicker.prototype.openPanel = function () {
        if (!this.loaded) {
            this.productsEl.innerHTML = '<p class="daetool-search-result-app-picker__empty">加载中...</p>';
        }
        else {
            this.renderCategories();
            this.renderProducts();
        }
        this.panelOpen = true;
        this.panel.hidden = false;
        this.panel.removeAttribute('hidden');
        this.pickerRoot.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
    };
    SearchResultAppPicker.prototype.closePanel = function () {
        this.panelOpen = false;
        this.panel.hidden = true;
        this.panel.setAttribute('hidden', '');
        this.pickerRoot.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
    };
    SearchResultAppPicker.prototype.renderCategories = function () {
        var _this = this;
        var allItem = "\n      <li>\n        <button type=\"button\"\n          class=\"daetool-search-result-app-picker__category".concat(this.activeCategoryId === ALL_CATEGORY_ID ? ' is-active' : '', "\"\n          data-id=\"").concat(ALL_CATEGORY_ID, "\">\u5168\u90E8</button>\n      </li>");
        var levelItems = this.categories
            .map(function (cat) { return "\n      <li>\n        <button type=\"button\"\n          class=\"daetool-search-result-app-picker__category".concat(cat.id === _this.activeCategoryId ? ' is-active' : '', "\"\n          data-id=\"").concat(cat.id, "\">").concat(cat.name, "</button>\n      </li>"); })
            .join('');
        this.categoriesEl.innerHTML = allItem + levelItems;
        Tool.$_selectAll(this.categoriesEl, '.daetool-search-result-app-picker__category').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this.activeCategoryId = Number(btn.getAttribute('data-id'));
                _this.renderCategories();
                _this.renderProducts();
            });
        });
    };
    SearchResultAppPicker.prototype.getActiveProducts = function () {
        var _this = this;
        var _a;
        if (this.activeCategoryId === ALL_CATEGORY_ID) {
            return this.allProducts;
        }
        var cat = this.categories.find(function (c) { return c.id === _this.activeCategoryId; });
        return (_a = cat === null || cat === void 0 ? void 0 : cat.children) !== null && _a !== void 0 ? _a : [];
    };
    SearchResultAppPicker.prototype.renderProducts = function () {
        var _this = this;
        var list = this.getActiveProducts();
        if (!list.length) {
            this.productsEl.innerHTML = '<p class="daetool-search-result-app-picker__empty">暂无应用</p>';
            return;
        }
        this.productsEl.innerHTML = list
            .map(function (item) {
            var isActive = _this.selectedProduct && String(_this.selectedProduct.g_id) === String(item.g_id);
            var img = item.i_url || item.logo_url || '';
            return "\n        <button type=\"button\"\n          class=\"daetool-search-result-app-picker__product".concat(isActive ? ' is-active' : '', "\"\n          data-gid=\"").concat(item.g_id, "\">\n          <img src=\"").concat(img, "\" alt=\"\" onerror=\"this.style.visibility='hidden'\">\n          <span>").concat(item.g_name, "</span>\n        </button>");
        })
            .join('');
        Tool.$_selectAll(this.productsEl, '.daetool-search-result-app-picker__product').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                var gid = btn.getAttribute('data-gid');
                if (!gid) {
                    return;
                }
                _this.closePanel();
                _this.pendingGid = gid;
                _this.pendingProductAlias = '';
                _this.navigate(gid);
            });
        });
    };
    SearchResultAppPicker.prototype.renderSelectedUi = function () {
        var _a;
        if (!this.selectedProduct) {
            this.clearSelectedUi();
            return;
        }
        this.triggerText.textContent = '请选择软件';
        this.selectedLogo.src = this.selectedProduct.i_url || this.selectedProduct.logo_url || '';
        this.selectedName.textContent = this.selectedProduct.g_name;
        this.selectedWrap.classList.remove('is-hidden');
        (_a = document.getElementById('result')) === null || _a === void 0 ? void 0 : _a.classList.add('has-selected-app');
    };
    SearchResultAppPicker.prototype.clearSelectedUi = function () {
        var _a;
        this.selectedProduct = null;
        this.triggerText.textContent = '请选择软件';
        this.selectedWrap.classList.add('is-hidden');
        (_a = document.getElementById('result')) === null || _a === void 0 ? void 0 : _a.classList.remove('has-selected-app');
        this.notifySelectionChange();
    };
    return SearchResultAppPicker;
}());
export default SearchResultAppPicker;
